export default __webpack_public_path__ + "static/media/discord-icon.7024b80d.svg";